/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Cms_TitleInputs */

const en_landing_features_cms_title = /** @type {(inputs: Landing_Features_Cms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content Management`)
};

const zh_landing_features_cms_title = /** @type {(inputs: Landing_Features_Cms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容管理`)
};

/**
* | output |
* | --- |
* | "Content Management" |
*
* @param {Landing_Features_Cms_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_cms_title = /** @type {((inputs?: Landing_Features_Cms_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Cms_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_cms_title(inputs)
	return zh_landing_features_cms_title(inputs)
});
export { landing_features_cms_title as "landing.features.cms.title" }